module.exports = {
      id: "success-icon-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#success-icon",
      toString: function () {
        return this.url;
      }
    }